import { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { SplashScreen } from 'src/components/loading-screen';
import PolicyGuard from 'src/auth/guard/policy-guard';

// ----------------------------------------------------------------------

const OnboardingPage = lazy(() => import('src/sections/Onboarding/onboarding-page'));

// ----------------------------------------------------------------------

export const onboardingRoutes: RouteObject[] = [
  {
    path: 'onboarding',
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<SplashScreen />}>
            <PolicyGuard
              requirements={{
                needsAuth: true,
                needsCompany: true,
                needsOnboardingComplete: false,
              }}
              fallback={<SplashScreen />}
            >
              <OnboardingPage />
            </PolicyGuard>
          </Suspense>
        ),
      },
      // Legacy redirects — all old step paths redirect to the single-page flow
      { path: 'welcome', element: <Navigate to="/onboarding" replace /> },
      { path: 'suppliers', element: <Navigate to="/onboarding" replace /> },
      { path: 'warehouses', element: <Navigate to="/onboarding" replace /> },
      { path: 'products', element: <Navigate to="/onboarding" replace /> },
      { path: 'stock-recount', element: <Navigate to="/onboarding" replace /> },
      { path: 'mapped-sku', element: <Navigate to="/onboarding" replace /> },
      { path: 'settings', element: <Navigate to="/onboarding" replace /> },
      { path: 'billing', element: <Navigate to="/onboarding" replace /> },
      { path: 'complete', element: <Navigate to="/onboarding" replace /> },
      { path: 'locations', element: <Navigate to="/onboarding" replace /> },
    ],
  },
];
